import React from "react"
import { useQuery } from "@apollo/client"
import GET_INVENTORY from "../../../graphql/queries/inventory/GetInventory"
import dayjs from "dayjs"
import DotLoader from "../../Ui/DotLoader"
import ErrorMessage from "../../Ui/Messages/ErrorMessage"
import { Container, Dates, LoaderContainer, Wrapper } from "./Shared.styled"

type Props = {
  inventoryId: string
  stock: number
  created: string
  updated: string
}

function InventoryRow({ inventoryId, stock, created, updated }: Props) {
  const { data, loading, error } = useQuery(GET_INVENTORY, { variables: { id: inventoryId } })

  if (error)
    return (
      <ErrorMessage
        message={
          <>
            Error loading Inventory [{error.message}]
          </>
        }
      />
    )

  return (
    <Container>
      <Wrapper>
        {loading ? (
          <LoaderContainer>
            <DotLoader />
          </LoaderContainer>
        ) : (
          <b>{data.getInventory.name}</b>
        )}
      </Wrapper>
      <div>
        <b>Quantity</b>: {stock}
      </div>
      <Dates>
        <div>
          <b>Created</b>: {dayjs(created).format("YYYY-MM-DD")}
        </div>
        <div>
          <b>Updated</b>: {dayjs(updated).format("YYYY-MM-DD")}
        </div>
      </Dates>
    </Container>
  )
}

export default InventoryRow
